<template>
	<div class="animated fadeIn">

		<div class="row">
			<div class="col-xs-12">

				<h2>
					<i class="fa fa-fire text-success"></i>
					<span>用户列表</span>
				</h2>
			</div>
		</div>

		<div class="row">

			<div class="col-xs-12">
				<NbFilter :pager="pager" :callback="search"></NbFilter>
			</div>

			<div v-for="user in pager.users" class="col-xs-12 bg-white pv10 mt10 cursor"
			     @click.stop.prevent="$router.push('/cgd/by/user/profile/' + user.id)">

				<div class="media">
					<div class="pull-left">
						<img class="img-rounded img-md" v-if="user.avatar && user.avatar.url" :src="user.avatar.url">
						<img class="img-rounded img-md" v-else src="../../../common/assets/img/avatar.png">
					</div>

					<div class="pull-right action-buttons">
						<a title="编辑" @click.stop.prevent="$router.push('/cgd/by/user/edit/'+user.id)">
							<i class="fa fa-pencil text-info f20"></i>
						</a>
						<a href="javascript:void(0)" title="删除" @click.stop.prevent="confirmDel(user)">
							<i class="fa fa-trash text-danger f20"></i>
						</a>
					</div>
					<div class="media-body">
						<div>
							<span class="f15">{{user.nickname}}</span>
							<span v-for="tag in user.tags" class="mr5 label label-default">{{user.role.name}}</span>
						</div>
						<small class="block m-t-xs m-b-xs text-muted">{{user.description}}</small>
						<span class="mr10">#{{user.id}}</span>
						<span class="mr10">上次登录: {{user.lastTime | simpleDateTime}}</span>
						<span class="mr10">上次IP: {{user.lastIp}}</span>
					</div>
				</div>
			</div>

			<div class="col-xs-12 mt20">
				<NbPager :pager="pager" :callback="refresh"></NbPager>
			</div>

		</div>


	</div>

</template>
<script>

	import NbFilter from '../../../common/widget/filter/NbFilter.vue'
	import NbPager from '../../../common/widget/NbPager.vue'
	import {MessageBox, Notification} from 'element-ui'

	import Pager from  "../../../common/model/base/Pager"
	import User from  "../../../common/model/user/User"

	export default {

		data () {
			return {
				pager: new Pager(User)
			}
		},
		components: {
			NbFilter,
			NbPager
		},
		computed: {},
		watch: {},
		methods: {

			search(){
				this.pager.page = 0;
				this.refresh()
			},
			refresh(){
				this.pager.httpFastPage();
			},
			confirmDel(user){
				let that = this;
				MessageBox.confirm('此操作将永久删除该用户, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function () {
						that.fetchDel(user);
					},
					function () {

					}
				);
			},
			fetchDel(user){

				let that = this;
				user.httpDel(function () {
					Notification.success({
						message: '成功删除用户!'
					});
					that.refresh();
				});
			}
		},
		mounted(){
			this.pager.enableHistory();
			this.refresh();
		}
	}

</script>



// WEBPACK FOOTER //
// List.vue?346f1e0b